var App = App || {};

App.AnchorLinks = (function ($) {
    "use strict";


    function init() {
        $('.anchor-links a[href^="#"]').on('click', function (e) {
            e.preventDefault();

            var target = this.hash,
                $target = $(target);

            $('html, body').stop().animate({
                'scrollTop': $target.offset().top - 150
            }, 900);

            console.log($target.offset().top - 150);
        });

    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.AnchorLinks.init();
});

